import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isSubmitted:false,
        users:[]
    },
    mutations: {



        toggle_isSubmitted(state,status){
            state.isSubmitted = status
        },

        SET_USERS(state,users){
            state.users = users
        }
    },
    actions: {

        //  fetchUsers({commit}){
        //     try{
        //
        //         commit('SET_USERS',await getUsers())
        //         commit('toggle_progress_bar',false)
        //
        //     }catch (e) {
        //         // this.errror = 'Whoops! Something Went wrong.'
        //     }
        // }
    },
    modules: {
    }
})